export { default as exPng } from "./excel.png";
export { default as woPng } from "./word.png";
